import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotifierService } from 'angular-notifier';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl, FormGroup } from '@angular/forms';
import { GlobalApiService } from 'src/app/services/global-api.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  private readonly notifier: NotifierService;
  // status = 0;
  role = '0';
  roles: any[] = [];
  users = new MatTableDataSource(<any>[]);
  editArray: any[] = [];
  updateArray: any[] = [];
  columnsToDisplay = [
    'first_name',
    'email',
    'gender',
    'role_id',
    'registration_request_note',
    'user_status',
    'actions',
  ];

  showDetails: boolean = false;
  userId: number | null = null;

  isDataLoading: boolean = false;

  form: FormGroup = new FormGroup({
    userStatusId: new FormControl(2),
    roleId: new FormControl(0),
    searchText: new FormControl(''),
    searchInChilds: new FormControl(false),
  });

  constructor(
    private httpClient: HttpClient,
    private globalApiService: GlobalApiService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
    // this.status = localStorage.status;
    this.role = localStorage['roleId'];
  }

  applyFilter(event: any) {
    const filterValue = event.target.value;
    this.users.filter = filterValue.trim().toLowerCase();
  }

  applyAllFilters() {
    console.log('applying all filters');
    const filterValues = this.form.value;
    console.log(filterValues);
    filterValues.userStatusId =
      filterValues.userStatusId >= 0 ? filterValues.userStatusId : null;
    filterValues.roleId = filterValues.roleId || null;
    filterValues.searchText = filterValues.searchText?.toLowerCase() || null;
    this.globalApiService.getAllUsers(filterValues).subscribe({
      next: (response: any) => {
        console.log(response);
        this.users = new MatTableDataSource(response);
      },

      error: (error) => {
        console.log(error);
        this.notifier.notify('error', 'Unable to fetch users');
      },
    });
  }
  ngOnInit() {
    if (localStorage['roleId'] === '1') {
      this.httpClient
        .get('/api/roles', {
          headers: {
            Authorization: 'Bearer ' + localStorage['accessToken'],
          },
        })
        .subscribe(
          (response: any) => {
            console.log(response);
            this.roles = response;
          },
          (error) => {
            console.log(error);
            this.notifier.notify('error', 'Unable to fetch roles');
          }
        );
      this.applyAllFilters();
    }
  }

  // editFunction = index => {
  //   if (this.editArray.indexOf(index) < 0) {
  //     this.editArray.push(index);
  //   }
  // };

  // cancelEdit = index => {
  //   this.editArray.splice(this.editArray.indexOf(index), 1);
  //   // this.users[index] = {
  //   //   first_name: "abc",
  //   //   last_name: "bca",
  //   //   user_status: 2,
  //   //   role_id: 1,
  //   //   gender: 1,
  //   //   registration_request_note: "bla"
  //   // };
  //   console.log(this.users);
  // };

  changeInitiated = (userId: any) => {
    if (this.editArray.indexOf(userId) < 0) {
      this.editArray.push(userId);
    }
  };

  saveUserData = (userId: any) => {
    console.log('save clicked');
    if (this.updateArray.indexOf(userId) < 0) {
      console.log('reached inside');
      this.updateArray.push(userId);
      console.log(userId);
      const userIndex = this.users.data.findIndex(
        (user: any) => user.user_id === userId
      );
      console.log(userIndex, this.users.data[userIndex]);
      const userData: any = this.users.data[userIndex];
      console.log(userData);
      this.httpClient
        .put(
          '/api/admin_user_status_change',
          {
            user_id: userData.user_id,
            user_status: parseInt(userData.user_status),
            role_id: parseInt(userData.role_id),
          },
          {
            headers: {
              Authorization: 'Bearer ' + localStorage['accessToken'],
            },
          }
        )
        .subscribe(
          (response) => {
            console.log(response);
            this.editArray.splice(this.editArray.indexOf(userId), 1);
            this.updateArray.splice(this.updateArray.indexOf(userId), 1);
            this.notifier.notify(
              'success',
              'Successfully updated user details'
            );
          },
          (error) => {
            this.updateArray.splice(this.updateArray.indexOf(userId));
            this.notifier.notify('error', 'Unable to update user details');
          }
        );
    }
  };

  openUserDetails(userId: number) {
    this.showDetails = true;
    this.userId = userId;
  }
}
